<template>
  <div class="section-toggles col-100">
    <router-link
      @click.native="updateAnalytics('overview')"
      :to="{
        name: 'disease-progression',
        params: { name: 'mobility', year: $store.state.year },
      }"
      class="overview-btn"
    >
      Overview</router-link
    >
    <router-link
      @click.native="updateAnalytics('detailed')"
      :to="{
        name: 'visualization',
        params: {
          name: 'mobility',
          year: $store.state.year,
          startTab: 'mobility',
        },
      }"
      :class="
        $store.state.currentDetailedTab !== '' ? 'router-link-active' : ''
      "
      class="overview-btn"
    >
      Detailed</router-link
    >
  </div>
</template>

<script>
export default {
  name: "InvTabs",
  props: {},
  data() {
    return {
      activeLink: "overview",
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    updateAnalytics: function (type) {
      this.$gtag.event("click", {
        event_category: `set_view`,
        event_label: type,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.section-toggles {
  text-align: center;
  margin-bottom: 25px;
}

.detailed-btn,
.overview-btn {
  background: $blue-dark;
  border: 1px solid $grey-darkest;
  color: $white;
  padding: 7px 25px;
  font-weight: $font-weight-bold;
  text-decoration: none;
  &.router-link-active {
    color: $blue-dark;
    background: $white;
  }
}
</style>
